
<div>
  <a-dropdown style="display: inline-block; height: 100%; vertical-align: initial">
    <span style="cursor: pointer">
      <a-avatar class="avatar" size="small" shape="circle" :src="avatar" :loadError="handleAvatarError"/>
      <span class="curr-user">{{user.username}}</span>
    </span>
    <a-menu style="width: 150px" slot="overlay">
      <a-menu-item @click="openProfile">
        <a-icon type="user"/>
        <span>个人中心</span>
      </a-menu-item>
      <a-menu-item @click="updatePassword">
        <a-icon type="key"/>
        <span>密码修改</span>
      </a-menu-item>
      <a-menu-divider></a-menu-divider>
      <a-menu-item @click="handleSettingClick">
        <a-icon type="setting"/>
        <span>系统定制</span>
      </a-menu-item>
      <a-menu-divider></a-menu-divider>
      <a-menu-item @click="handleLogoutClick">
        <a-icon type="logout"/>
        <span>退出登录</span>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
  <a-modal
    title="退出确认"
    :visible="logoutConfirmVisible"
    :confirmLoading="loggingOut"
    okText="确定退出"
    cancelText="取消"
    @ok="logout"
    @cancel="logoutConfirmVisible = false"
  >
    <p>确定要退出当前账号吗？</p>
  </a-modal>
  <update-password
    @success="handleUpdate"
    @cancel="handleCancelUpdate"
    :user="user"
    :updatePasswordModelVisible="updatePasswordModelVisible">
  </update-password>
</div>
